<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <Password
      :model-value="modelValue"
      name="password"
      :feedback="false"
      toggle-mask
      class="w-full"
      :class="error?.length ? '' : 'mb-5'"
      :pt:pcinputtext:root:id="id"
      :pt:pcinputtext:root:class="[
        error?.length ? 'border-red-400' : 'border-gray-300',
        'form-input focus:ring-0',
      ]"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <div class="form-error mt-0.5" :class="error?.length ? '' : 'invisible'">
      {{ error?.length ? error[0] : '' }}
    </div>
  </div>
</template>

<script>
import Password from 'primevue/password';
import { v4 as uuid } from 'uuid';

export default {
  name: 'PasswordInput',
  components: { Password },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    error: {
      type: [Array, null],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`;
      },
    },
  },
  emits: ['update:modelValue'],
};
</script>
